<template>
  <div>
    <!-- 搜索框  S -->
    <div class="serach">
      <div class="gc fl">
        <select name id>
          <option value="中国語">中国語</option>
          <option value="日本語">日本語</option>
        </select>
      </div>
      <input type="text" placeholder="商品キーワードまたはアリババ、タオバオの商品URL" @keydown.enter="search" v-model="val" ref="input" />
      <button class="fl" @click="search">
        <img src="../../assets/img/user_home/search.png" alt />
      </button>
      <form action>
        <div class="serach-img el-icon-camera">
          <input class="file" type="file" @change="uploadFile" multiple="multiple" title=" " />
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { upload, offerImageSearch } from "../../api/API/home";
import { taobaoShortUrl } from "../../api/API/list";
export default {
  data() {
    return {
      value: "",
      options: [
        {
          value: "选项1",
          label: "中国語",
        },
      ],
      val: "",
      index: 0,
      open: "",
    };
  },
  computed: {
    ...mapState(["result", "exchangeRate"]),
  },
  created() {
    this.val = this.$route.query.result;
    this.isLoading(false);
  },
  mounted() {
    this.$refs["input"].addEventListener("paste", this.handlePaste);
  },
  directives() {
    this.$refs["input"].removeEventListener("paste", this.handlePaste);
  },
  methods: {
    ...mapMutations([
      "searchResult",
      "classifResult",
      "imgSearch",
      "isLoading",
    ]),
    search() {
      var reg = RegExp(/1688|taobao|tmall|m.tb.cn/);
      let regtaobao = RegExp(/taobao/);
      let reg1688 = RegExp(/1688.com/);
      let regtmall = RegExp(/tmall/);
      let mtb = RegExp(/m.tb.cn|e.tb.cn/);
      let regtwsy = RegExp(/wsy/);
      let type = "";
      var reg1 = /1688.com\/offer\/([0-9]+)/;
      var reg4 = /m\.1688\.com.*offerId=([0-9]{10,})/; //1688手机
      var reg2 = /[?|&]id=(\d{10,15})/;
      var reg3 = /detail.tmall.com.*&id=([0-9]+)/;
      let id = "";
      if (regtwsy.test(this.val)) {
        return this.$message.error(
          "中国アリババ、タオバオのURLをご記入ください"
        );
      }
      // 判断是哪个网站的商品链接
      if (regtaobao.test(this.val)) {
        type = "taobao";
        id = this.val.match(reg2)[1];
        this.val = "https://item.taobao.com/item.htm?id=" + id;
      } else if (reg1688.test(this.val)) {
        type = "1688";
        if (this.val.match(reg1) == null) {
          id = this.val.match(reg4)[1];
        } else {
          id = this.val.match(reg1)[1];
        }
        this.val = "https://detail.1688.com/offer/" + id + ".html?";
      } else if (regtmall.test(this.val)) {
        type = "tmall";
        id = this.val.match(reg2)[1];
        this.val = "https://detail.tmall.com/item.htm?id=" + id;
      } else if (mtb.test(this.val)) {
        let datas = {
          str: this.val,
        };
        taobaoShortUrl(datas).then((res) => {
          if (res.code != 0) return false;
          let routeUrl = this.$router.resolve({
            path: "details1688?iid=" + res.data.iid + "&type=" + res.data.type,
          });
          window.open(routeUrl.href, "_blank");
        });
        return false;
      }
      if (this.val == undefined || this.val.trim() == "") {
        return this.$message.warning(
          "商品キーワードまたはアリババ、タオバオの商品URLを入力してください"
        );
      }
      // 判断不在商品列表页里搜索
      if (this.$route.name != "list" && this.$route.name != "list1688") {
        // this.classifResult("");
        // 判断搜索框里是否有1688，天猫，淘宝链接

        if (reg.test(this.val)) {
          let routeUrl = this.$router.resolve({
            path: "/details1688?iid=" + id + "&type=" + type,
          });
          window.open(routeUrl.href, "_blank");
        } else {
          let routeUrl = this.$router.resolve({
            path: "/list1688?result=" + this.val + "&type=taobao",
          });
          window.open(routeUrl.href, "_blank");
        }
      } else {
        if (this.val != "") {
          // 搜索的内容是否是链接搜索
          if (reg.test(this.val)) {
            let routeUrl = this.$router.resolve({
              path: "/details1688?iid=" + id + "&type=" + type,
            });
            window.open(routeUrl.href, "_blank");
          } else {
            this.$router.push({
              query: (this.$route.query, { result: this.val, type: "taobao" }),
            });
          }
          this.$parent.$parent.resetPageNum();
          this.$parent.$parent.getList();
        }
      }
    },
    //粘贴图片搜索
    handlePaste(e) {
      let clipboardData = e.clipboardData;
      console.log(clipboardData.files);
      let file;

      if (
        clipboardData &&
        clipboardData.files &&
        clipboardData.files.length > 0
      ) {
        file = clipboardData.files[0];
      }

      if (typeof file === "undefined") {
        return;
      }
      if (clipboardData.files[0].type.indexOf("image") != -1) {
        let param = new FormData();
        param.append("imageData", file);
        this.upload(param);
      }
    },
    //  上传图片搜索
    uploadFile(event) {
      let file = event.target.files[0];
      let param = new FormData();
      param.append("imageData", file);
      this.upload(param);
    },
    // 图片搜索
    upload(param) {
      this.isLoading(true);
      upload(param).then((res) => {
        if (res.code != 1)
          return this.$message.error("图片搜索失败，请重新选择");
        offerImageSearch({ imgUrl: res.data }).then((res) => {
          if (res.code == -1) {
            this.isLoading(false);
            this.$router.push('/login');
            return false;
          }
          res.data.forEach((item) => {
            item.picurl = item.main_image_url
            item.iid = item.item_id;
            item.type = 'taobao';


          });
          this.imgSearch(res.data);
          this.isLoading(false);
          if (this.$route.name != "list1688") {

            this.$router.push({ name: "list1688", query: { img: "list" } });
          } else {
            this.$router.push({
              query: (this.$route.query, { img: "img" + this.index++ }),
            });
            this.$parent.$parent.imgList();
            this.$parent.$parent.resetPageNum();
          }
        });
      });
    },
  },
  watch: {
    open() {
      window.open(this.newWin, "_blank");
    },
  },
};
</script>
<style lang='scss' scoped>
.serach {
  position: absolute;
  top: 50px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 99;

  //   width: 800px;

  .gc {
    width: 80px;
    height: 36px;
    border: 2px solid #f3c622;
    border-right: none;
    font-size: 14px;
    text-align: center;
    line-height: 36px;
    position: relative;

    select {
      width: 86px;
      height: 36px;
      border: 0;
      color: #333;
      /*清除select的边框样式*/
      /*清除select聚焦时候的边框颜色*/
      outline: none;
      border: none;
      /*隐藏select的下拉图标*/
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      padding-left: 10px;
      color: #787878;
      border-right: 1px solid #e9e9e9;

      //   background-color: #cfccc9;
      color: #222;
      font-size: 14px !important;
      //   font-weight: 700;
    }
  }

  .gc:after {
    content: "";
    width: 12px;
    height: 6px;
    position: absolute;
    background: url("../../assets/img/user_home/pulldown.png") no-repeat;
    background-size: 100%;
    top: 15px;
    right: 3px;
    /*给自定义的图标实现点击下拉功能*/
    /*pointer-events: none;鼠标事件拜拜的意思。元素应用了该CSS属性，链接啊，点击啊什么的都变成了浮云。*/
    pointer-events: none;
  }

  input {
    float: left;
    width: 515px;
    height: 36px;
    border: 2px solid #f3c622;
    border-left: 2px solid #f3c622;
    border-right: none;
    font-size: 18px;
    padding-left: 16px;

    // color: #F3C622;
    // &:focus {
    //   color: red;
    // }
    &::placeholder {
      color: #ccc;
      padding-left: 10px;
      font-size: 14px;
    }
  }

  button {
    width: 40px;
    height: 40px;
    background: #f3c622;
    border: none;
    cursor: pointer;

    img {
      margin-top: 5px;
      width: 20px;
    }
  }

  .serach-img {
    position: absolute;
    top: 7px;
    right: 50px;
    font-size: 25px;
    text-align: center;

    &:hover {
      color: #f3c622;
    }

    input {
      position: absolute;
      top: 0;
      left: -20px;
      opacity: 0;
      width: 40px;
      height: 20px;
      border: 0;
      cursor: pointer;
    }
  }
}
</style>